import React, { Component } from 'react';
import Categories from './components/Categories/Categories';
import Category from './components/Category/Category';

class YoutubeSong extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCategories: {
                show: true,
                categoryId: ''
            },
            // Giữ tab app ở container để KHÔNG bị reset khi vào chi tiết rồi back về danh sách.
            appFilter: 'YOKARA'
        };
    }

    updateShowCategory = value => {
        this.setState({
            showCategories: value
        })
    }

    setAppFilter = app => {
        this.setState({
            appFilter: app
        })
    }

    render() {
        const { showCategories, appFilter } = this.state;

        return (
            <>
                {
                    showCategories.show ?
                        <Categories
                            updateShowCategory = { this.updateShowCategory }
                            appFilter = { appFilter }
                            setAppFilter = { this.setAppFilter }
                        />
                        : <Category
                            updateShowCategory = { this.updateShowCategory }
                            showCategories = { this.state.showCategories }
                        />
                }
            </>
        );
    }
}

export default YoutubeSong
